export default "__VITE_ASSET__2AUFv$9L__"